import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { submit } from './navigation.thunk';
import { NavigationState } from './navigation.type';

export const initialNavigationState: NavigationState = {
  name: '',
  email: '',
  mobile: '',
  message: '',
  topic: '',
  submission: {
    status: 'idle',
  },
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState: initialNavigationState,
  reducers: {
    setName: (state, { payload }: PayloadAction<string>) => {
      state.name = payload;
    },
    setEmail: (state, { payload }: PayloadAction<string>) => {
      state.email = payload;
    },
    setMobile: (state, { payload }: PayloadAction<string>) => {
      state.mobile = payload;
    },
    setMessage: (state, { payload }: PayloadAction<string>) => {
      state.message = payload;
    },
    setTopic: (state, { payload }: PayloadAction<string>) => {
      state.topic = payload;
    },
  },
  extraReducers: {
    [submit.pending.toString()]: (state) => {
      state.submission.status = 'loading';
      state.submission.error = undefined;
    },
    [submit.rejected.toString()]: (state, { error: { message } }: { error: { message: string } }) => {
      state.submission.status = 'error';
      state.submission.error = message;
    },
  },
});

export const navigationReducer = navigationSlice.reducer;
export const navigationActions = navigationSlice.actions;
